import React, { useContext, useEffect } from 'react';
import {AuthContext} from "../auth/AuthContext";

export const UserInformationPane: React.FunctionComponent = () => {
    const { isLoggedIn, name, signOut } = useContext(AuthContext);

    useEffect(() => {
        document.title = name;
    });

    if (!isLoggedIn) {
        return null;
    }
    return (
        <div className="info-panel">
            <button type="button" className="button" onClick={signOut}>🔒<br />Afmelden</button>
        </div>
    );
};